export const getStatsDataFromFilterList = (filterListInFunciton) => {
    const statsData = {
      genderFClick: 0, // 성별 여성 클릭수 총합
      genderFView: 0, // 성별 여성 노출수 총합
      genderMView: 0, // 성별 남성 노출수 총합
      genderMClick: 0, // 성별 남성 노출수 총합
      click: [
        { name: "1세", total: 0 },
        { name: "2세", total: 0 },
        { name: "3세", total: 0 },
        { name: "4세", total: 0 },
        { name: "5세", total: 0 },
        { name: "6세", total: 0 },
        { name: "7세", total: 0 },
        { name: "8세", total: 0 },
        { name: "9세", total: 0 },
        { name: "10세", total: 0 },
      ], // 연령별 클릭수 총합
      view: [
        { name: "1세", total: 0 },
        { name: "2세", total: 0 },
        { name: "3세", total: 0 },
        { name: "4세", total: 0 },
        { name: "5세", total: 0 },
        { name: "6세", total: 0 },
        { name: "7세", total: 0 },
        { name: "8세", total: 0 },
        { name: "9세", total: 0 },
        { name: "10세", total: 0 },
      ], // 연령별 뷰수 총합
    };
  
    filterListInFunciton.forEach((dataFromApi, i) => {
      statsData.genderFClick = statsData.genderFClick + dataFromApi.gender_f_click;
      statsData.genderFView = statsData.genderFView + dataFromApi.gender_f_view;
      statsData.genderMClick = statsData.genderMClick + dataFromApi.gender_m_click;
      statsData.genderMView = statsData.genderMView + dataFromApi.gender_m_view;
  
      for (var iAgeInData = 1; iAgeInData < 10; iAgeInData++){
        const iAgeInStats = iAgeInData - 1;
        statsData.click[iAgeInStats].total = statsData.click[iAgeInStats].total + dataFromApi[`age_${iAgeInData}_click`];
        statsData.view[iAgeInStats].total = statsData.view[iAgeInStats].total + dataFromApi[`age_${iAgeInData}_view`];
      }
      
    });
  
    return statsData
  };